<div class="modal-container">
  <div class="email-header">
    <span class="title">{{titleStr}}</span>
    <span class="close" id="btn_updateContact_closeModal" tabindex="0" role="button" aria-label="Close dialog" (click)="onClose()" (keydown.enter)="onClose()" (keydown.space)="onClose()"></span>
  </div>
  <div *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
      <div class="toast-content">
        <div class="toast-text">
          <div class="toast-title" *ngIf="toastTitle">{{ toastTitle }}</div>
          <div class="toast-message-text">{{ toastMessageText }}</div>
        </div>
        <span class="material-symbols-outlined f-24 cursor-pointer" tabindex="0" (click)="closeToast()"
          (keypress)="closeToast()" title="Close">close</span>
      </div>
    </div>
  </div>
  <div class="email-inner-panel">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 formField">
        <label for="email">{{emailLabel}}<span class="requiredField">*</span>
        </label>
        <input tabindex="0" placeholder="user@example.com" type="email" id="inputfield_updateContact_email"
          maxlength="255" [disabled]="disableFlag" [(ngModel)]="newEmail" (ngModelChange)="validateEmail(newEmail)" (focus)="onEmailFocus()"
          aria-label="Enter your email address" autocomplete="email" />
        <!-- <div id="error_updateContact_invalidEmail" role="alert" class="text-danger mt-1 err-font">
          <div *ngIf="newEmail === '' && fieldFocus">{{ errorMessage?.M0014 }}</div>
          <div *ngIf="invalidEmail  && newEmail !== '' && !emailTooLong">{{ errorMessage?.M0015 }}</div>
          <div *ngIf="emailTooLong">Email must be at most 255 characters.</div>
          <div *ngIf="emailAlredyExist">{{ errorMessage?.M0085 }}</div>
        </div> -->
        <div id="error_updateContact_invalidEmail" role="alert" *ngIf="invalidEmailFormate" class="text-danger mt-1 err-font">
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <div class="row" *ngIf="showSecond">
      <div class="otp-section">
        <div class="otp-label">
          <label>Verification Code</label>
          <span class="requiredField">*</span>
        </div>

        <div class="otp-input-container">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="0" id="inputfield_updateContact_otp0" [(ngModel)]="otp[0]"
            (focus)="onOtpFocus()" (blur)="onOtpBlur()" #otpFirst tabindex="0" aria-label="OTP digit 1" (keydown.enter)="onOtpBlur()" (keydown.space)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="1" id="inputfield_updateContact_otp1" [(ngModel)]="otp[1]"
            (focus)="onOtpFocus()" (blur)="onOtpBlur()" tabindex="0" aria-label="OTP digit 2" (keydown.enter)="onOtpBlur()" (keydown.space)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="2" id="inputfield_updateContact_otp2" [(ngModel)]="otp[2]"
            (focus)="onOtpFocus()" (blur)="onOtpBlur()" tabindex="0" aria-label="OTP digit 3" (keydown.enter)="onOtpBlur()" (keydown.space)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="3" id="inputfield_updateContact_otp3" [(ngModel)]="otp[3]"
            (focus)="onOtpFocus()" (blur)="onOtpBlur()" tabindex="0" aria-label="OTP digit 4" (keydown.enter)="onOtpBlur()" (keydown.space)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="4" id="inputfield_updateContact_otp4" [(ngModel)]="otp[4]"
            (focus)="onOtpFocus()" (blur)="onOtpBlur()" tabindex="0" aria-label="OTP digit 5" (keydown.enter)="onOtpBlur()" (keydown.space)="onOtpBlur()">
          <input type="tel" inputmode="numeric" maxlength="1" class="otp-input" data-index="5" id="inputfield_updateContact_otp5" [(ngModel)]="otp[5]"
            (focus)="onOtpFocus()" (blur)="onOtpBlur()" tabindex="0" aria-label="OTP digit 6" (keydown.enter)="onOtpBlur()" (keydown.space)="onOtpBlur()">
        </div>
        <div id="error_updateContact_otpInput" *ngIf="showOtpError || (otpTouched && !fieldFocus && otp.join('').length === 0)" class="text-danger err-font">
          {{ errorMessage }}
        </div>


       <div class="timer-section">
          <button class="resend-button" id="btn_updateContact_resendOtp" (click)="resendOtp()" [disabled]="isOtpResendButtonDisabled" tabindex="0" aria-label="Resend verification code" (keydown.enter)="resendOtp()" (keydown.space)="resendOtp()">Resend Code</button>
          <div class="timer" *ngIf="timerActive">
            {{ timerDisplay }}
          </div>
          <div class="timer" *ngIf="showVerificationTimer">
            {{ getVerificationBlockTimeDisplay() }}
          </div>
          <div class="timer" *ngIf="showResendTimer">
            {{ getCurrentFieldBlockTimeDisplay() }}
          </div>
        </div>
      </div>
    </div>
    <div class="email-footer">
      <button type="button" class="btn btn-primary fullWidth"
        *ngIf="!showSecond && (type === 'primaryEmail')" (click)="sendVerification()"
        [disabled]="isEmailSendButtonDisabled" [ngClass]="{'disabled': isEmailSendButtonDisabled}"
        id="btn_updateContact_sendEmailVerification" tabindex="0" aria-label="Send verification code" (keydown.enter)="sendVerification()" (keydown.space)="sendVerification()">
        Send Verification Code
      </button>
      
      <button type="button" class="btn btn-primary fullWidth" *ngIf="showSecond" (click)="verifyOtp()"
        [disabled]="isOtpVerifyButtonDisabled" [ngClass]="{'disabled': isOtpVerifyButtonDisabled}"
        id="btn_updateContact_verifyOtp" tabindex="0" aria-label="Verify OTP and update email" (keydown.enter)="verifyOtp()" (keydown.space)="verifyOtp()">
        {{verifyUpdate}}
      </button>

    </div>
  </div>